module.exports = __webpack_public_path__ + "img/36.28b45a28.png";